import { AxiosResponse } from "axios";
import { BASE_METHODS } from "../../constants/action-types";

import { store } from "../../store";
import { createCall } from "../base";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { TextEnum } from "../../constants/text";
import { timeoutError } from "../../constants/reducers/base.reducer";
import {
  setUserActionStart,
  setUserErrorMessage,
} from "../../constants/reducers/user.reducer";
import { GetAllUserXlsxDataDTO } from "../../constants/dto/user";
let body: GetAllUserXlsxDataDTO;

export const getAllUserXlsxData = async () => {
  store.dispatch(setUserActionStart(true));

  const request = await createCall(
    "cms/users/xlsx",
    BASE_METHODS.GET,
    "application/json",
    "1.0.0"
  );

  try {
    const response = request as AxiosResponse;
    body = plainToClass(GetAllUserXlsxDataDTO, response.data);
    const errors = await validate(body);
    if (errors.length > 0) {
      store.dispatch(
        setUserErrorMessage(
          TextEnum.GET_ALL_USER_XLSX_RESPONSE_INVALID_RESPONSE
        )
      );
      return null;
    }
    return response.data;
  } catch (error) {
    store.dispatch(setUserActionStart(false));
    store.dispatch(timeoutError());
    return null;
  }
};
